import { flexRender, RowData, Table } from "@tanstack/react-table";

import { TableHead } from "../../Table/Head";
import { HeadCell } from "../../Table/HeadCell";

import { tstColumnMeta, tstColumnWidth } from "./columnMeta";

export interface TSTHeadProps<T> {
    table: Table<T>;
}

export function TSTHead<T extends RowData>({ table }: TSTHeadProps<T>) {
    return (
        <TableHead>
            {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                        const canSort = header.column.getCanSort();
                        const isLeftPinned =
                            header.column.getIsPinned() === "left";
                        const meta = tstColumnMeta(header.column);
                        return (
                            <HeadCell
                                key={header.id}
                                data-pendo={meta?.headerPendoId}
                                isSorted={header.column.getIsSorted()}
                                onClick={
                                    canSort
                                        ? () => header.column.toggleSorting()
                                        : undefined
                                }
                                canSort={canSort}
                                width={tstColumnWidth(header.column, table)}
                                left={
                                    isLeftPinned
                                        ? header.column.getStart("left")
                                        : undefined
                                }
                                isPinned={isLeftPinned}
                            >
                                {header.isPlaceholder
                                    ? null
                                    : flexRender(
                                          header.column.columnDef.header,
                                          header.getContext()
                                      )}
                            </HeadCell>
                        );
                    })}
                </tr>
            ))}
        </TableHead>
    );
}
